import { Download, Share, X } from "lucide-react";
import { dismissInstallPrompt, promptInstall, useInstallState } from "../pwa/install";

/** Convite para instalar o app. Aparece só depois do login, não atrapalha o uso pelo navegador e pode ser dispensado. */
export function InstallPrompt() {
  const { mode, installed, dismissed } = useInstallState();
  if (installed || dismissed || mode === "none") return null;
  return <div className="install-banner" role="region" aria-label="Instalar aplicativo">
    <span className="install-banner-icon" aria-hidden="true"><img src="/icon.png" alt=""/></span>
    <div className="install-banner-copy">
      <strong>Instale o aplicativo</strong>
      {mode === "native"
        ? <p>Crie um atalho na tela inicial para abrir mais rápido e usar até sem internet. Você pode continuar usando pelo navegador.</p>
        : <p>No iPhone/iPad: toque em <Share size={14} aria-label="Compartilhar" className="install-inline-icon"/> <b>Compartilhar</b> e depois em <b>Adicionar à Tela de Início</b>.</p>}
    </div>
    {mode === "native" && <button type="button" className="button primary" onClick={() => void promptInstall()}><Download size={16} aria-hidden="true"/> Instalar</button>}
    <button type="button" className="install-banner-close" onClick={dismissInstallPrompt} aria-label="Agora não"><X size={18} aria-hidden="true"/></button>
  </div>;
}
